import { render, staticRenderFns } from "./OnlineFormsPreview.vue?vue&type=template&id=b829d3b0&scoped=true"
import script from "./OnlineFormsPreview.vue?vue&type=script&lang=js"
export * from "./OnlineFormsPreview.vue?vue&type=script&lang=js"
import style0 from "./OnlineFormsPreview.vue?vue&type=style&index=0&id=b829d3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b829d3b0",
  null
  
)

export default component.exports